import { render, staticRenderFns } from "./StoryFullView.vue?vue&type=template&id=4d8244e2"
import script from "./StoryFullView.vue?vue&type=script&lang=js"
export * from "./StoryFullView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports